<script setup lang="ts">
import { onMounted, watch } from "vue";
import { Composer } from "vue-i18n";
import i18n from "@/i18n";

import TheHeader from "./components/TheHeader.vue";
import TheMenu from "./components/TheMenu.vue";
import TheFooter from "./components/TheFooter.vue";

import "normalize.css";
import "@/assets/sass/common.scss";
import { useTaskStore } from "./store/task";

const num = Math.floor(Math.random() * 6) + 1;
document.body.classList.add(`bg${num}`);

const currentLocale = (i18n.global as unknown as Composer).locale;

const setHtmlLang = (localeString: string) => {
  switch (localeString) {
    case "en-US": {
      document.getElementsByTagName("html")[0].lang = "en";
      break;
    }
    case "ja-JP": {
      document.getElementsByTagName("html")[0].lang = "ja";
      break;
    }
  }
};
setHtmlLang(currentLocale.value);

watch(currentLocale, (value) => {
  setHtmlLang(value);
});

onMounted(() => {
  const taskStore = useTaskStore();
  taskStore.init();
});

</script>

<template>
  <TheHeader />
  <TheMenu />
  <main>
    <router-view />
  </main>
  <TheFooter />
</template>

<style scoped lang="scss">
@import "@/assets/sass/mixin.scss";

@include mq(sp) {
  main {
    width: 100%;
  }
}

@include mq(pc) {
  main {
    width: 90%;
  }
}

</style>
